export const getAlertTypeString = (alertType) => {
  switch (alertType) {
    case 0:
      return 'ALERT';
    case 1:
      return 'ANOMALY';
    case 2:
      return 'CRS';
    default:
      return '';
  }
};
